import { createUuid } from '../../../../core/utils/uuid';
import type { ProblemNode } from '../../../../core/interfaces/backend/proyectos/project-sections.interface';
import type { ProblemTree } from '../../../../core/interfaces/backend/proyectos/project-sections.interface';
import type { NodeKind } from '../../../../core/interfaces/backend/proyectos/project-sections.interface';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ProjectDialogService } from '../../../../core/services/project-dialog.service';
import { FormsModule } from '@angular/forms';

@Component({ selector: 'app-problem-tree', standalone: true, imports: [FormsModule], templateUrl: './problem-tree.component.html', styleUrl: './problem-tree.component.css' })
export class ProblemTreeComponent {
    private readonly dialogs = inject(ProjectDialogService);
    @Input({ required: true })
    tree!: ProblemTree;
    @Input() saved = false;
    @Input() dirty = false;
    @Input()
    readOnly = false;
    @Input()
    saving = false;
    @Output()
    changed = new EventEmitter<void>();
    @Output()
    save = new EventEmitter<void>();
    @Output()
    cancel = new EventEmitter<void>();
    error = '';
    readonly groups: {
        kind: NodeKind;
        label: string;
    }[] = [{ kind: 'cause', label: 'Causas Directas' }, { kind: 'indirectCause', label: 'Causas Indirectas' }, { kind: 'effect', label: 'Efectos Directos' }, { kind: 'indirectEffect', label: 'Efectos Indirectos' }];
    items(kind: NodeKind) { return this.tree.nodes.filter(n => n.kind === kind); }
    parents(kind: NodeKind) { return this.items(kind === 'indirectEffect' ? 'effect' : 'cause'); }
    add(kind: NodeKind): void { if (!this.tree.central.trim() || kind !== 'cause' && !this.parents(kind).length) {
        this.error = 'Primero registre el problema central y el elemento padre correspondiente.';
        return;
    } this.tree.nodes.push({ id: createUuid(), kind, parent: null, description: '' }); this.changed.emit(); this.error = ''; }
    async remove(node: ProblemNode): Promise<void> {
        if (this.readOnly || this.saving) return;
        if (this.tree.nodes.some(n => n.parent === node.id)) {
        this.error = 'El registro tiene información asociada que debe eliminar previamente.';
        return;
    } if (await this.dialogs.confirm('¿Está seguro que desea eliminar este registro? El cambio se aplicará al guardar la sección.')) {
        this.tree.nodes = this.tree.nodes.filter(n => n.id !== node.id);
        this.error = '';
        this.changed.emit();
    } }
    get complete(): boolean { const causes = this.items('cause'), effects = this.items('effect'); return !!this.tree.central.trim() && causes.length > 0 && effects.length > 0 && this.tree.nodes.every(n => !!n.description.trim() && (n.kind === 'cause' || this.parents(n.kind).some(p => p.id === n.parent))) && causes.every(c => this.items('indirectCause').some(n => n.parent === c.id)) && effects.every(e => this.items('indirectEffect').some(n => n.parent === e.id)); }
}
